module.exports = __webpack_public_path__ + "static/media/animated-clock.337b5170.svg";